<template>
  <div class="page-search">
    <!-- 搜索框 -->
    <form action="javascript:return true;">
      <div class="search-wrap" :class="{hasNavigation: navigationTitle.length > 0}">
        <div class="search-input" @click="handleClickSearchBox()">
          <img class="ic-search" :src="searchIcon" />
          <input
            ref="inputKwElement"
            class="input-box"
            v-show="!showSearchResult"
            type="search"
            placeholder="搜索商品标题或关键字"
            v-model="inputKeywords"
            @keyup.enter="handleSearch({ secKwId: -1, name: inputKeywords, goodsNum: 0 })"
          />
          <div class="search-keywords" v-show="showSearchResult">
            <span class="search-text">{{ selectedKeywords }}</span>
            <img class="ic-close" :src="closeIcon" @click="handleClickClearKeywords()" />
          </div>
          <img
            class="ic-clear"
            :src="clearIcon"
            v-show="(showSearchResult && selectedKeywords.length > 0) || (!showSearchResult && inputKeywords.length > 0)"
            @click="handleClickClearKeywords()"
          />
        </div>
        <span class="btn-search" v-show="!showSearchResult" @click="handleSearch({ secKwId: -1, name: inputKeywords, goodsNum: 0 })">搜索</span>
      </div>
    </form>
    <div
      class="no-search-result"
      v-show="
        showSearchResult &&
          !isLoadingGoodsList &&
          ((isSearchGoodsList && !goodsListData.loadMore && goodsListData.data.length === 0) ||
            (!isSearchGoodsList && keywordCateGoodsList.length === 0))
      "
    >
      搜索不到商品, 再换个关键字吧~
    </div>
    <!-- 搜索的商品列表 -->
    <div class="goods-list-wrap" :class="{hasNavigation: navigationTitle.length > 0}" v-show="showSearchResult && isSearchGoodsList">
      <md-scroll-view ref="scrollView" :scrolling-x="false" @refreshing="onPullingDownRefresh" @end-reached="onPullingUp">
        <md-scroll-view-refresh
          slot="refresh"
          slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
          :scroll-top="scrollTop"
          :is-refreshing="isRefreshing"
          :is-refresh-active="isRefreshActive"
        ></md-scroll-view-refresh>
        <div class="goods-list">
          <SingleGoodsItem
            :key="`${goodsItem.goodsId}_${index}`"
            v-for="(goodsItem, index) in goodsListData.data"
            :item="goodsItem"
            :isSearchPage="true"
            :channel="channel"
          />
        </div>
        <md-scroll-view-more slot="more" :is-finished="!isLoadingGoodsList && !goodsListData.loadMore"></md-scroll-view-more>
      </md-scroll-view>
    </div>
    <!-- 搜索的商品列表(通过关键字分类搜索的,无分页) -->
    <div class="goods-list-wrap" :class="{hasNavigation: navigationTitle.length > 0}" v-show="showSearchResult && !isSearchGoodsList">
      <md-scroll-view ref="scrollView2" :scrolling-x="false" :auto-reflow="true">
        <div class="goods-list">
          <SingleGoodsItem
            :key="`${goodsItem.goodsId}_${index}`"
            v-for="(goodsItem, index) in keywordCateGoodsList"
            :item="goodsItem"
            :isSearchPage="false"
            :channel="channel"
          />
        </div>
      </md-scroll-view>
    </div>
    <div class="m-search-wrap" v-show="!showSearchResult && hotSearchList.length > 0">
      <div class="search-head">
        <span>热门搜索</span>
      </div>
      <ul class="search-list">
        <li
          :key="item.name"
          class="search-item"
          :style="{ color: item.goodsNum === 0 ? searchKeyColors[0] : item.goodsNum === 1 ? searchKeyColors[1] : searchKeyColors[2] }"
          v-for="item in hotSearchList"
          @click="handleSearch(item)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <!-- 历史搜索 -->
    <div
      class="m-search-wrap"
      :class="{ borderTop: !showSearchResult && historySearchList.length > 0 && hotSearchList.length > 0 }"
      v-show="!showSearchResult && historySearchList.length > 0"
    >
      <div class="search-head">
        <span>历史搜索</span>
        <span class="btn-clear" @click="clearSearchHistory()">清除</span>
      </div>
      <ul class="search-list">
        <li
          :key="item.name"
          class="search-item"
          :style="{ color: item.goodsNum === 0 ? searchKeyColors[0] : item.goodsNum === 1 ? searchKeyColors[1] : searchKeyColors[2] }"
          v-for="item in historySearchList"
          @click="handleSearch(item, true)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <JdTabs />
  </div>
</template>

<script>
import LocalStore from '@/utils/localStore'
import { mapGetters } from 'vuex'
import Consts from '@/common/consts'
import { getPageData } from '@/utils/help'
import SingleGoodsItem from '@/components/singleGoodsItem'
import { Toast, ScrollView, ScrollViewRefresh, ScrollViewMore } from 'mand-mobile'
import JdTabs from '@/components/jdTabs'
export default {
  name: 'search',
  components: {
    JdTabs,
    SingleGoodsItem,
    [ScrollView.name]: ScrollView,
    [ScrollViewRefresh.name]: ScrollViewRefresh,
    [ScrollViewMore.name]: ScrollViewMore,
  },
  data() {
    return {
      channel: 'jd',
      storeKey: '',
      searchIcon: require('../../assets/ic_search.png'),
      clearIcon: require('../../assets/ic_clear.png'),
      closeIcon: require('../../assets/ic_white_close.png'),
      searchKeyColors: ['#333', '#0db2b4', '#a567f1'], // 搜索item的字体颜色
      isLoadingGoodsList: false,
      inputKeywords: '', // 输入的关键字
      selectedKeywords: '', // 选中的关键字
      showSearchResult: false, // 显示搜索结果
      isSearchGoodsList: true, // 是搜索的商品列表 或 关键字分类商品列表
      offsetTop: 0,
      hotSearchList: [], // 热门搜索列表
      historySearchList: [], // 历史搜索列表
      keywordCateGoodsList: [], // 关键字分类商品列表
      goodsListData: {
        // 搜索的关键字列表
        currentPage: 1,
        pageSize: 20,
        total_count: 0,
        loadMore: true,
        data: [],
      },
    }
  },
  computed: {
    ...mapGetters([ 'navigationTitle' ]),
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      let AlivePages = ['productDetail']
      if (from.name !== null && AlivePages.indexOf(from.name) > -1) {
        vm.$_setScrollPosition()
      } else {
        vm.initData()
      }
    })
  },
  deactivated() {
    this.offsetTop = this.$refs.scrollView.getOffsets().top
  },
  methods: {
    initData() {
      const storeKeyMap = {
        tbk: Consts.STORE_HISTORY_SEARCH,
        pdd: Consts.STORE_PDD_HISTORY_SEARCH,
        jd: Consts.STORE_JD_HISTORY_SEARCH,
      }
      this.storeKey = storeKeyMap[this.channel]
      this.isLoadingGoodsList = false
      this.inputKeywords = ''
      this.selectedKeywords = ''
      this.showSearchResult = false
      this.isSearchGoodsList = true
      this.offsetTop = 0
      this.keywordCateGoodsList = []
      this.initSearchHistory()
      this.resetSearchGoodsList()
      if (this.hotSearchList.length === 0) {
        this.fetchHotSearchList()
      }
    },
    /**
     * 加载热门搜索列表
     */
    fetchHotSearchList() {
      this.$http[this.channel].hotSearch().then(res => {
        this.hotSearchList = res.data
      })
    },
    /**
     * 设置滚动距离
     */
    $_setScrollPosition() {
      this.$nextTick(() => {
        const scrollVM = this.$refs.scrollView
        if (scrollVM && this.offsetTop > 0) {
          setTimeout(() => {
            scrollVM.scrollTo(0, this.offsetTop, false)
            scrollVM.reflowScroller()
          }, 50)
        }
      })
    },
    /**
     * 点击搜索区域
     */
    handleClickSearchBox() {
      if (this.showSearchResult) {
        this.showSearchResult = false
        this.$nextTick(() => {
          this.$refs.inputKwElement.focus()
        })
      }
    },

    /**点击清除关键字 */
    handleClickClearKeywords() {
      this.inputKeywords = ''
      if (this.showSearchResult) {
        this.showSearchResult = false
        this.selectedKeywords = ''
        this.$nextTick(() => {
          this.$refs.inputKwElement.focus()
        })
      }
    },
    /**
     * 点击搜索
     */
    handleSearch(searchItem, isHistorySearch) {
      if (searchItem.name) {
        if (searchItem.goodsNum === 0) {
          // 搜索关键字
          this.searchByKeywords(searchItem.name)
          this.setSearchHistory(searchItem)
        } else if (searchItem.goodsNum === 1) {
          // 搜索单品
          this.$http[this.channel].searchKwCateGoods(searchItem.secKwId).then(res => {
            if (res.data.length >= 1) {
              this.$router.push({ name: 'productDetail', query: { goodsId: res.data[0].goodsId } })
            } else if (isHistorySearch) {
              // 历史搜索的单品搜索 搜索不到产品,则使用关键字搜索,并更新goodsNum=0
              searchItem.goodsNum = 0
              this.searchByKeywords(searchItem.name)
              this.setSearchHistory(searchItem)
            }
          })
        } else if (searchItem.goodsNum > 1) {
          // 搜索分类产品
          this.selectedKeywords = searchItem.name
          this.showSearchResult = true
          this.isLoadingGoodsList = true
          this.isSearchGoodsList = false
          this.$refs.scrollView.scrollTo(0, 0, false)
          this.$refs.scrollView2.scrollTo(0, 0, false)
          this.$http[this.channel].searchKwCateGoods(searchItem.secKwId)
            .then(res => {
              this.keywordCateGoodsList = res.data
              this.isLoadingGoodsList = false
              if (res.data.length === 0 && isHistorySearch) {
                // 历史搜索的分类搜索 搜索不到产品,则使用关键字搜索,并更新goodsNum=0
                searchItem.goodsNum = 0
                this.searchByKeywords(searchItem.name)
                this.setSearchHistory(searchItem)
              }
            })
            .catch(() => {
              this.isLoadingGoodsList = false
            })
        }
      } else {
        Toast.info('请输入关键字~', 1500)
      }
    },
  /**
   * 通过关键字搜索
   */
    searchByKeywords(keywords) {
       this.selectedKeywords = keywords
        this.showSearchResult = true
        this.isLoadingGoodsList = false
        this.isSearchGoodsList = true
        this.resetSearchGoodsList() // 重置搜索的商品列表
        this.fetchSearchGoodsList(1)
    },

    /**
     * 重置搜索的商品列表
     */
    resetSearchGoodsList() {
      if (this.$refs.scrollView) {
        this.$refs.scrollView.scrollTo(0, 0, false)
      }
      this.goodsListData.currentPage = 1
      this.goodsListData.total_count = 0
      this.goodsListData.loadMore = true
      this.goodsListData.data = []
    },
    onPullingDownRefresh() {
      if (this.selectedKeywords.length > 0) {
        this.fetchSearchGoodsList(1, true)
      }
    },
    onPullingUp() {
      if (this.selectedKeywords.length > 0) {
        if (this.goodsListData.loadMore) {
          this.fetchSearchGoodsList(this.goodsListData.currentPage + 1)
        }
      }
    },
    /**
     * 搜索商品列表
     */
    fetchSearchGoodsList(currentPage, isPullingDownRefresh) {
      if (this.isLoadingGoodsList) return
      this.isLoadingGoodsList = true
      this.$http[this.channel].search(this.selectedKeywords, currentPage)
        .then(res => {
          this.goodsListData = getPageData(currentPage, this.goodsListData, res)
          if (isPullingDownRefresh || currentPage === 1) {
            // 下拉刷新
            this.$refs.scrollView.finishRefresh()
            this.$refs.scrollView.finishLoadMore() // 重置加载更多
          }
          if (currentPage > 1) {
            // 加载更多
            this.$refs.scrollView.finishLoadMore()
          }
          this.isLoadingGoodsList = false
          this.$nextTick(() => {
            this.$refs.scrollView.reflowScroller()
          })
        })
        .catch(() => {
          this.isLoadingGoodsList = false
        })
    },
    /**
     * 初始化搜索历史记录
     */
    initSearchHistory() {
      this.historySearchList = LocalStore.get(this.storeKey, [])
    },
    /**
     * 设置搜索历史记录
     */
    setSearchHistory(searchItem) {
      let arr = LocalStore.get(this.storeKey, [])
      let isExist = false
      for (let item of arr) {
        if (item.name === searchItem.name) {
          // 存在历史记录中, 则更新旧数据
          isExist = true
          item.secKwId = searchItem.secKwId
          item.goodsNum = searchItem.goodsNum
        }
      }
      if (!isExist) {
        // 不存在历史记录中,则追加
        arr.push(searchItem)
      }
      this.historySearchList = arr
      LocalStore.set(this.storeKey, arr)
    },
    /**
     * 清空搜索历史记录
     */
    clearSearchHistory() {
      this.historySearchList = []
      LocalStore.set(this.storeKey, [])
    },
  },
}
</script>

<style lang="scss" scoped>
.page-search {
  position: relative;
  overflow: hidden;
  min-height: 100%;
  background: #fff;
  .search-wrap {
    margin-top: 0.2rem;
    padding: 0.2rem 0.2rem 0.2rem 0;
    display: flex;
    height: 0.84rem;
    align-items: center;
    &.hasNavigation {
      margin-top: 0;
    }
    .search-input {
      margin-left: 0.3rem;
      display: flex;
      align-items: center;
      flex: 1;
      height: 0.64rem;
      background: #f4f4f4;
      border-radius: 0.64rem;
      .ic-search {
        margin-left: 0.2rem;
        width: 0.26rem;
        height: 0.26rem;
      }
      .input-box {
        flex: 1;
        font-size: 0.24rem;
        padding: 0.12rem 0.24rem 0.12rem 0.12rem;
        height: 0.64rem;
        line-height: normal;
        border: none;
        outline: none;
        background: transparent;
        &::-webkit-input-placeholder {
          color: #9c9c9c;
        }
      }
      .ic-clear {
        margin-left: auto;
        width: 0.7rem;
        height: 0.64rem;
        padding: 0.12rem 0.2rem 0.12rem 0.1rem;
      }
      .search-keywords {
        position: relative;
        display: flex;
        align-items: center;
        margin-left: 0.2rem;
        font-size: 0.24rem;
        background: #999;
        color: #fff;
        border-radius: 0.44rem;
        padding: 0 0.42rem 0 0.3rem;
        height: 0.44rem;
        .search-text {
          max-width: 3rem;
          height: 0.44rem;
          line-height: 0.44rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: inline-block;
        }
        .ic-close {
          position: absolute;
          height: 0.44rem;
          padding: 0.14rem 0.16rem 0.14rem 0.08rem;
          top: 0;
          right: 0;
          display: inline-block;
        }
      }
    }
    .btn-search {
      display: inline-block;
      height: 0.56rem;
      line-height: 0.56rem;
      margin-left: 0.12rem;
      padding: 0 0.2rem;
      color: #f42f19;
      font-size: 0.3rem;
      font-weight: bold;
    }
  }
  .no-search-result {
    margin-top: 2rem;
    text-align: center;
    font-size: 0.28rem;
    color: #c5c5c5;
  }
  .goods-list-wrap {
    position: absolute;
    top: 1.1rem;
    bottom: 1rem;
    left: 0;
    width: 100%;
    &.hasNavigation {
      top: 0.9rem;
    }
    .goods-list {
      padding: 0 0.2rem;
    }
  }
  .m-search-wrap {
    margin: 0.2rem 0.4rem 0;
    &.borderTop {
      margin-top: 0.4rem;
      padding-top: 0.16rem;
      border-top: 0.02rem solid #eeefef;
    }
    .search-head {
      display: flex;
      align-items: center;
      height: 0.6rem;
      font-size: 0.3rem;
      color: #262626;
      font-weight: bold;
      .btn-clear {
        margin-left: auto;
        color: #333;
        font-weight: normal;
        font-size: 0.28rem;
        padding: 0.1rem 0 0 0.2rem;
        &:active {
          color: #c5c5c5;
        }
      }
    }
    .search-list {
      margin-top: 0.2rem;
      width: 100%;
      overflow: auto;
      padding: 0 0.1rem;
      .search-item {
        float: left;
        min-width: 1.34rem;
        max-width: 3rem;
        height: 0.52rem;
        margin: 0 0.2rem 0.2rem 0;
        padding: 0 0.18rem;
        background: #f2f2f2;
        border-radius: 0.04rem;
        line-height: 0.52rem;
        font-size: 0.26rem;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
        &:active {
          opacity: 0.4;
        }
      }
    }
  }
}
</style>
